<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<div class="right-cointainer" style="text-align:right;">
      <div>{{imieNazwiskoZamawiajacego}}</div>
      <div>(Zleceniodawca)</div>
    </div>
<div style="page-break-before: always;"></div>
<p align="center" style="margin-top:20px;">
    <strong>UMOWA ZLECENIA</strong>
</p>
<p>
    Zawarta w Łodzi, pomiędzy:
</p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>
  , z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, o kapitale
  zakładowym w wysokości 1 664 600,00 zł, reprezentowaną przez: 
</p>
<p>
  <strong>{{zamawiajacy}}</strong>, zwaną w dalszej części Umowy <strong>Zleceniodawcą</strong>
</p>
<p>
  a​ Panem/Panią: {{imieNazwisko}}
  <br/>
  adres zamieszkania: {{zamieszkany}}
  <br/>
  seria i numer dowodu osobistego: {{nrDowodu}}
  <br/>
  PESEL: {{pesel}}
  <br/>
  Nr konta bankowego: {{nrRachunku}}
  <br/>
  na które należy dokonywać wypłat z tytułu realizacji zlecenia.
  <br/>
  <br/>
  zwanym w dalszej części umowy <strong>Zleceniobiorcą</strong> o następującej treści:
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p>
<ol>
  <li>
    Zleceniodawca zleca, a Zleceniobiorca zobowiązuje się do wykonywania czynności polegających na:
  </li>
  <ol type="a">
  <li>
    rzetelnym  przygotowaniu  i prowadzeniu zajęć zdalnych z Gitary zgodnie z programem edukacyjnym szkoły Tutore Poland oraz harmonogramem zajęć.
    Harmonogram może mieć formę pliku elektronicznego.
  </li>
  <li>
    prowadzeniu dokumentacji zajęć, tj.: dziennika zajęć, listy obecności, listy testów, gier i zabaw, sprawozdania z realizacji zajęć;
  </li>
  <li>
    terminowym wykonywaniu wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych,
  </li>
  <li>
    Współpracy z osobami i podmiotami współpracującymi ze Zleceniodawcą, w tym w szczególności z koordynatorami oraz metodykami szkoły Tutore Poland 
    oraz innymi osobami wyznaczonym przez Zleceniodawcę do koordynowania pracy w szkole Tutore Poland, przy czym  Zleceniobiorca zobowiązany jest do 
    regularnego i niezwłocznego  (najpóźniej niż na koniec każdego dnia roboczego) odczytywania wiadomości wysyłanych przez te osoby poprzez pocztę e-mail,
    wiadomości sms lub poprzez komunikatory internetowe i w razie potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w tym szczególnie:
  </li>
  <ol style="list-style-type: lower-roman;">
    <li>
      przekazywanie  niezbędnych informacji w zakresie określonym w danej sytuacji;
    </li>
    <li>
    udział w zebraniach, rozmowach pohospitacyjnych i ewaluacjach.  
    </li>
    <li>
      Współpracy z rodzicami uczniów, w tym szczególnie:
    </li>
  </ol>
</ol>
  <ol>
    <li>
    odpisywaniu na maile,
    </li>
    <li>
    przekazywaniu prac domowych oraz ocen,
  </li>
  <li>
  raportowanie postępów uczniów raz na 2 miesiące, 
  </li>
  <li>
  udziale w spotkaniach z rodzicami.
  </li>
  </ol>
    <li>
    Celem zapewnienia warunków do wykonania niniejszej Umowy, Zleceniodawca zobowiązuje się do udostępnienia wszystkich  niezbędnych materiałów dydaktycznych,
    takich jak podręczniki, panele edukacyjne, grafiki do prezentacji oraz  indywidualnego konta w systemie do nauki online. Powyższe nie obejmuje sprzętu 
    elektronicznego niezbędnego do prowadzenia zajęć online (komputer, sprzęt nagłaśniający, itp.), które Zleceniobiorca zobowiązany jest zorganizować na 
    własny koszt.
    </li>
</ol>
</p>
<p></p>
<br><br/>
<br><br/>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<ol>
  <li>
    Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się będzie online za pośrednictwem platform udostępnionych przez Zleceniodawcę.
  </li>
  <li>
    Zleceniodawca umożliwi Zleceniobiorcy korzystanie z platform niezbędnych do prowadzenia zajęć.
  </li>
  <li>
  Strony ustalają, iż za jednostkę obliczeniową przyjmuje się 60 minut zajęć według ustalonego harmonogramu wraz z czynnościami dodatkowymi związanymi 
  z organizacją zajęć oraz wypełnianiem raportów po zajęciach.
  </li>
  <li>
    Łączny wymiar godzin dydaktycznych do wykonania będzie określony w harmonogramie każdorazowo przez Zleceniodawcę z wyprzedzeniem i podsumowany na 
    koniec każdego miesiąca kalendarzowego.
  </li>
  <li>
    Strony dopuszczają zmiany dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.
  </li> 
</ol>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3 Obowiązki Zleceniobiorcy</strong>
</p>
  <ol>
  <li>
  Zleceniobiorca, zobowiązuje się do należytego wykonania przedmiotu zlecenia, w szczególności do:
  </li>
  <ol type="a">
    <li>
    prowadzenia zajęć wskazanych w §1 zgodnie z harmonogramem przesłanym przez Koordynatora najpóźniej ostatniego dnia miesiąca poprzedzającego miesiąc, 
    w którym zlecenie ma zostać wykonane;
    </li>
    <li>
    współpracy z przydzielonym Koordynatorem oraz Team Leaderem;
    </li>
    <li>
    rzetelnego prowadzenia dokumentacji potwierdzającej realizację zajęć, zawierającej w szczególności: dzienniki zajęć, listy obecności, dokumentację dotyczącą 
    ewaluacji uczniów, sprawozdania z realizacji zajęć - w formie ustalonej przez Zleceniodawcę;
    </li>
    <li>
    prowadzenia zajęć odrobieniowych;
    </li>
    <li>
    prowadzenia inwentaryzacji;
    </li>
    <li>
    realizowania celów projektu w zakresie zajęć poprzez:
    </li>
      <ul class="dashed">
      <li>
        motywowanie ucznia do samodzielnej pracy i przezwyciężania trudności,
      </li>
      <li>
        kształcenie umiejętności niezbędnych do dalszej nauki,
      </li>
      <li>
        kształcenie postawy badawczej,
      </li>
      <li>
        naukę logicznego myślenia,
      </li>
      <li>
        prezentowanie efektów swojej pracy;
      </li>
      </ul>
  <li>
    wykonywania wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych;
  </li>
  <li>
    dbania o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia;
  </li>
  <li>
    wykonywania zlecenia w sposób zgodny z przepisami i zasadami bezpieczeństwa i higieny pracy;
  </li>
</ol>
  <li>
  Zleceniobiorca zobowiązany jest do rzetelnego przygotowania i prowadzenia zajęć zgodnie z autorskim programem edukacyjnym oraz harmonogramem.
  </li>
  <li>
  Zleceniobiorca odpowiedzialny jest za jakość i terminowość prowadzonych zajęć.
  </li>
  <li>
  Zleceniobiorca ponosi pełną odpowiedzialność za szkody wyrządzone przez swoje działania lub zaniechania podczas wykonywania przedmiotu umowy, w 
  szczególności w razie niedotrzymania terminu wykonania zlecenia Zleceniobiorca odpowiada za szkody poniesione przez Zleceniodawcę, natomiast przy 
  stwierdzeniu błędów i wad przedmiotu umowy – zobowiązany jest do bezpłatnego ich usunięcia.
  </li>
  <li>
    Zleceniobiorca zobowiązany jest do bezzwłocznego informowania Zleceniodawcy o każdym przypadku uniemożliwiającym mu realizację zajęć zgodnie z harmonogramem.
  </li>
  <li>
    Zleceniobiorca zobowiązany jest do stosowania się do zapisów Ustawy z dnia 29 sierpnia 1997r o ochronie danych osobowych (tj. DZ.U. z 2002r .Nr 101. Poz. 926 
    ze zmianami).
  </li>
  <li>
  Zleceniobiorca nie może zlecać wykonania przedmiotu niniejszej umowy osobom trzecim. 
  </li>
  <li>
    Naruszenie zakazu, o którym mowa w ust. 7 spowoduje, iż osoba trzecia nie zostanie dopuszczona do wykonania jakichkolwiek czynności i nie otrzyma z tego tytułu 
    żadnego wynagrodzenia.
  </li>
</ol>
<br>
<br><br/>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4  Absencje i powiadamianie o nich</strong>
</p>
<ol>
<li>
W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy zobowiązuje 
się on do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie, nie później niż 3 dni przed planowanymi zajęciami. W takim przypadku Zleceniodawca może 
wyznaczyć osobę, która zastąpi Zleceniobiorcę w wykonaniu zlecenia opisanego w niniejszej umowie.
</li>
<li>
  W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 3-dniowego okresu 
  powiadomienia o niemożności wykonywania zlecenia. Zleceniobiorca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia, powiadomić o 
  takiej sytuacji Zleceniodawcę.
</li>
<li>
  W przypadku niemożliwości zrealizowania przez Zleceniobiorcę przedmiotu umowy zgodnie z harmonogramem spowodowanej usprawiedliwioną nieobecnością trwającą w 
  miesiącu nie dłużej niż pięć dni roboczych w sumie lub następujących kolejno po sobie, przy czym przez usprawiedliwioną nieobecność rozumie się wyłącznie nieobecność 
  udokumentowaną zwolnieniem lekarskim lub innym dokumentem urzędowym. Zleceniobiorca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nieodbytym 
  zajęciom, w innym terminie uzgodnionym ze Zleceniobiorcą.
</li>
<li>
  Strony dopuszczają zmiany dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.
</li>
<li>
  W przypadku nieprzyjścia na zajęcia określone w harmonogramie zaakceptowanym przez Zleceniobiorcę i niepowiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem 
  nie mniejszym niż 1 dzień, Zleceniodawca może naliczyć Zleceniobiorcy karę w wysokości 200 zł (słownie: dwieście złotych). W takim przypadku Zleceniodawca może 
  rozwiązać Umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. Zleceniodawca może ponadto dochodzić odszkodowania od Zleceniobiorcy z tytułu szkód 
  poniesionych w wyniku zaistnienia tego typu sytuacji do wysokości dwukrotności wartości zaistniałej szkody. Powyższy zapis nie dotyczy sytuacji losowych 
  uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości przyjścia na zajęcia.
</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5 Czas obowiązywania </strong>
</p>
<ol>
  <li>
    Strony zawierają umowę od dnia podpisania jej przez obie strony do dnia {{umowaDo}}.
  </li>
  <li>
    Strony ustalają, że niniejsza Umowa może zostać rozwiązana z zachowaniem 1-miesięcznego okresu wypowiedzenia, ze skutkiem na koniec miesiąca następującego po 
    miesiącu, w którym wypowiedzenie zostało doręczone drugiej Stronie.
  </li>
  <li>
    W przypadku rozwiązania Umowy Zleceniobiorca zobowiązuje się do zwrotu materiałów oraz sprzętu udostępnionego na czas trwania umowy przez Zleceniodawcę w 
    terminie do 14 dni po okresie wypowiedzenia. W przypadku braku zwrotu materiałów i sprzętu w wyznaczonym terminie Zleceniodawca może nałożyć na Zleceniobiorcę 
    karę finansową o wartości otrzymanych materiałów oraz sprzętu. Dodatkowo Zleceniobiorca może zostać obciążony kosztami przesyłki.
  </li>
</ol>

<div style="page-break-before: always;">
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 6 Wynagrodzenie</strong>
  </P>
<ol>
  <li
  v-if="typWynagrodzenia === '1' || typWynagrodzenia === ''"
  >
Tytułem wynagrodzenia Zleceniobiorca otrzyma kwotę w wysokości 17 zł brutto (słownie: siedemnaście złotych brutto) za 1 godzinę lekcyjną, trwającą 60 minut.
W przypadku przeprowadzenia lekcji pokazowej wynagrodzenie za każdą godzinę lekcji pokazowej wynosi 30,00 zł brutto (słownie: trzydzieści złotych).
  </li>
  <li
  v-else-if="typWynagrodzenia === '2'"
  >
Tytułem wynagrodzenia Zleceniobiorca otrzyma kwotę w określonej w tabeli nr 1 przedstawionej poniżej, zależnej od średniej liczby uczniów:
<br/>
<br/>
Tabela nr 1
     <table
     style="border: 1px solid; text-align: center;"
     >
    <tbody>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Średnia uczniów obecnych w danym miesiącu na grupie</span></p>
    </td>
    <td>
      
    <p class="cell-in-first-table"><span>Stawka brutto w złotych polskich za 60 minut lekcji</span></p>
    </td>
    </tr>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>1</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>18,30</span></p>
    </td>
    </tr>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>2</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>26</span></p>
    </td>
    </tr>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>3</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>30</span></p>
    </td>
    </tr>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>4</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>36</span></p>
    </td>
    </tr>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>5</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>40</span></p>
    </td>
    </tr>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>45</span></p>
    </td>
    </tr>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>7</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>50,05</span></p>
    </td>
    </tr>

    </tbody>
    </table>

    <p>W przypadku przeprowadzenia lekcji pokazowej wynagrodzenie za każdą godzinę lekcji pokazowej wynosi 30,00 zł brutto (słownie: trzydzieści złotych).</p>
  </li>
  <li>
Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje z dołu, do 15-tego dnia następnego miesiąca.
  </li>
  <li>
Wynagrodzenie jest płatne przelewem na nr konta bankowego wskazanego przez Zleceniobiorcę, <strong>na podstawie prowadzonej przez Zleceniobiorcę dokumentacji 
potwierdzającej realizację zajęć w danym miesiącu, w szczególności dzienników zajęć i list obecności uczniów.</strong>
  </li>
  <li>
Dokumentacja, o której mowa w § 6 ust. 3 powinna zostać uzupełniona najpóźniej do ostatniego dnia miesiąca, za który Zleceniobiorcy przysługuje wynagrodzenie 
z tytułu wykonania zlecenia.
  </li>
  <li>Zleceniodawca może przyznać premię uznaniowej w wysokości do 10% wartości wynagrodzenia brutto pod warunkiem bardzo wysokiej jakości prowadzonych lekcji i ich organizacji oraz zaangażowania w wykonywane zlecenia mierzonego elementami: 100% frekwencji, wypełnianie założeń merytorycznych i organizacyjnych określonych w niniejszej umowie oraz zgodnie z wytycznymi określonymi przez koordynatora. Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia okresu rozliczeniowego po miesiącu bądź kwartalnie w zależności od ustaleń pomiędzy stronami umowy.</li>
  <li>
  Zleceniodawca może obniżyć do 10% wartości wynagrodzenia brutto za dany miesiąc, w przypadku niestosowania się do zapisów: § 1 ust. 1, §3 ust. 1-3 zawartej umowy czy § 4 ust.1-4,, w szczególności:
  <ul>
    
  <li>niedotrzymywania podanej dyspozycyjności,</li>
  <li>nieodpisywania na e-maile oraz nie odbierania telefonów od osób wskazanych do kontaktu przez Zleceniodawcę,</li>
  <li>uzasadnionych skarg rodziców na jakość prowadzonych lekcji,</li>
  <li>niewywiązywania się z obowiązku oceniania dzieci w ramach co 2-miesięcznych raportów,</li>
  <li>niezachowywania zasad kultury osobistej na zajęciach oraz w kontakcie z osobami wskazanymi przez Zleceniodawcę,</li>
  <li>niewywiązywania się z wytycznych dotyczących programu i jakości prowadzonych zajęć edukacyjnych określonych przez Zleceniodawcę,</li>
  </ul>
  </li>
  </ol>
  </div>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7 Prowadzenie działalności gospodarczej</strong>
</p>
<ol>
<li>
Zleceniobiorca oświadcza, że nie prowadzi działalności gospodarczej w myśl Ustawy o swobodzie działalności gospodarczej (j.t. Dz. U. z 2010 r. Nr 220, poz.1447 z późn.
  zm.) w zakresie przedmiotu umowy.
</li>
<li>
Zleceniobiorca zobowiązuje się do niezwłocznego poinformowania Zleceniodawcy o zmianie stanu faktycznego określonego w ust. 1 w terminie 7 dni od dnia rozpoczęcia 
działalności gospodarczej.
</li>
<li>
Strony ustalają, że niniejsza umowa nie rodzi żadnych skutków w zakresie uprawnień pracowniczych wynikających ze stosunku pracy.
</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8 Zakaz konkurencji</strong>
</p>
  <ol>
  <li>
  Za działalność  konkurencyjną  w  rozumieniu  niniejszego paragrafu Strony uznają: oferowanie i prowadzenie wszelkich usług edukacyjnych związanych z nauczaniem gry 
  na Gitarze w jakiejkolwiek formie wszystkim klientom Zleceniobiorcy, którzy zakończyli współpracę ze Szkołą do 12 miesięcy po zakończeniu Umowy, lub obecnym Klientom Szkoły.
  </li>
  <li>
  Zleceniobiorca zobowiązuje się w czasie  trwania  współpracy  opisanej  niniejszą umową  nie prowadzić  działalności konkurencyjnej  względem  działalności  
  Zamawiającego wg definicji przedstawionej w punkcie 8.1.
  </li>
  <li>
  Jeżeli to Klient, który jest aktualnym Klientem szkoły, sam złoży propozycję współpracy Zleceniobiorcy, Zleceniobiorca ma obowiązek poinformowania Klienta o 
  ww. zakazie działalności konkurencyjnej oraz jest zobligowany do poinformowania Zleceniodawcy o zaistniałej sytuacji. 
  </li>
  <li>
  Zleceniodawca zastrzega sobie prawo do sprawdzenia względem Zleceniobiorcy, czy zapisy ww. paragrafu są należycie wykonywane przez Zleceniobiorcę.
  </li>
  <li>
  Za złamanie zapisu określonego w punkcie 8.1. Zleceniodawca może naliczyć Zleceniobiorcy karę w wysokości 20 000 zł
  </li>
  </ol> 
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 9 Forma umowy</strong>
</p>
<ol>
  <li> 
    Zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.
  </li>
  <li>
    W sprawach nieuregulowanych niniejszą umową mają zastosowanie przepisy Kodeksu Cywilnego.
  </li>
</ol>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 10 Właściwy Sąd</strong>
</p>
<p>
  Właściwym do rozpoznania sporów wynikających z niniejszej umowy będzie Sąd właściwy dla miejsca siedziby Zleceniodawcy.
</p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 11 Ilość umów</strong>
</p>
<p>
  Umowę sporządzono w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.
</p>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 15%;">{{zamawiajacy}}</span><br/>
        <span style="margin-left: 10%;">(Zleceniodawca)</span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 15%;">(Zleceniobiorca)</span>
    </div>
</div>



  <div style="margin-top:5px;page-break-before: always;">
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{data}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{pesel}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{email}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres zamieszkania</span><span class="caption">(ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{zamieszkany}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres korespondencyjny</span><span class="caption">(ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Urząd Skarbowy (zgodny z adresem zamieszkania)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{urzadSkarbowy}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{rencista}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności:</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia<br>(jeśli wpisano "TAK", proszę pominąć pkt. 5,6,7)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{student}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe<br>(tylko w przypadku objęcia ubezpieczeniem emerytalnym i rentowym)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę.<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie<br>jest wyższe bądź równe krajowej płacy minimalnej:</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu<br>niż umowa o pracę i/lub umowa cywilno-prawna z Tutore Poland Sp. z o.o.</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia:</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span><strong>
  Wypełnienie powyższego oświadczenia oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym,oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  Zobowiązuję się do poinformowania Pracodawcy w przypadku zmiany ww. danych w terminie 7 dni od daty zaistnienia zmiany. Wyrażam zgodę na podanie Administratorowi danych osobowych mojego numeru telefonu, adresu e-mail i adresu do korespondencji w Oświadczeniu Zleceniobiorcy, celem wysyłki rocznych deklaracji rozliczeniowych.
  <br/>
  </strong></span></p>
  </td>
  </tr>

  </tbody>
  </table>
  </div>



  <div style="margin-top:40px; page-break-before: always; font-size: 10px;">
  <p align="center" class="subheading"><strong>Informacja o ochronie danych osobowych </strong></p>
  <p style="margin-bottom: 0px;"><span>
  Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 
  z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku 
  z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych 
  oraz uchylenia dyrektywy 95/46/WE og&oacute;lne rozporządzenie o ochronie danych, 
  (&bdquo;Rozporządzenie&rdquo;) informujemy, że Administratorem Danych Osobowych jest: 
  </span></p>
  <p style="margin-bottom: 0px;"><em>
  <span>
  Tutore Poland Sp. z o.o. z siedzibą w Łodzi przy 
  ul. Piotrkowska 157A, 90-440 Ł&oacute;dź, 
  wpisana do rejestru przedsiębiorc&oacute;w pod numerem KRS: 0000670834, 
  sąd rejestrowy dla Łodzi Śr&oacute;dmieścia, XX Wydział Krajowego Rejestru Sądowego, 
  NIP: 7272812193.
  </span>
  </em></p>
  <p style="margin-bottom: 0px;">
  <span>
  Kontakt z Administratorem Danych Osobowych możesz uzyskać pisemnie, 
  kierując korespondencję na powyższy adres lub elektronicznie, korzystając z adresu e-mail: 
  </span>
  <a href="mailto:kadry@szkolam.pl"><span>kadry@szkolamm.pl</span></a>
  </p>
  <p><span>
  Dane osobowe są przetwarzane w celu zawarcia i realizacji zawartej umowy, 
  tj. na podstawie art. 6 ust. 1 lit. b &nbsp;Rozporządzenia. 
  Podanie danych jest dobrowolne, jednak konieczne w celu zawarcia i wykonania Umowy. 
  W związku z realizacją usług dane osobowe zostaną przekazane podmiotom zewnętrznym, 
  w tym w szczeg&oacute;lności dostawcom system&oacute;w i usług informatycznych, 
  bankom i operatorom płatności, podmiotom świadczącym usługi księgowe,prawne, audytowe, 
  konsultingowe, kurierom, oraz podmiotom powiązanym z Administratorem, 
  kt&oacute;rzy zajmują się realizacją zam&oacute;wień. Dane osobowe będą przechowywane 
  przez okres trwania umowy, a po jej zakończeniu przez czas wynikający z obowiązujących 
  przepis&oacute;w prawa lub do czasu przedawnienia wzajemnych roszczeń. Każda osoba, 
  kt&oacute;rej dane dotyczą ma prawo dostępu do swoich danych osobowych, żądania 
  ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo wniesienia sprzeciwu 
  wobec przetwarzania danych oraz prawo do przenoszenia danych. 
  W celu realizacji powyższych uprawnień należy skontaktować się 
  z Administratorem Danych Osobowych, korzystając z danych teleadresowych, 
  wskazanych powyżej. Osoba, kt&oacute;rej dane dotyczą ma także prawo wniesienia skargi 
  do organu nadzorczego, gdy uzna, iż przetwarzanie danych osobowych narusza przepisy prawa.
  </span></p>
  <p align="center" class="subheading" style="margin-bottom: 0px;">
  <strong>
  Upoważnienie<br>
  do przetwarzania danych osobowych w zbiorze w wersji<br>
  papierowej i elektronicznej
  </strong>
  </p>
  <p>&nbsp;</p>
  <p>
  <span>
  Niniejszym upoważniam Pana/Panią {{imieNazwisko}}
  do przetwarzania danych osobowych zawartych 
  w poniżej wymienionych zbiorach danych osobowych 
  w wersji papierowej i elektronicznej:
  </span>
  </p>
  <p>
  <ul>
  <li>
  zbiór danych osobowych:dzieci uczestniczących w zajęciach organizowanych przez Tutore Poland Sp. z o.o.
  </li>
  <li>
  zbiór danych osobowych: rodziców (opiekunów prawnych) dzieci uczestniczących w zajęciach organizowanych przez Tutore Poland Sp. z o.o.
  </li>
  </ul>
  </p>
  <p><span>w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami. </span></p>
  <p>
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
  </p>
  <p>
  Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
  </p>

  <p>
  Upoważnienie jest ważne do odwołania.
  </p>

  <p style="font-style: italic;">
  Oświadczam, iż zapoznałem się z przepisami dotyczących ochrony danych osobowych, w szczególności Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) oraz wdrożonymi obowiązkami związanymi z obowiązującą w Tutore Poland Sp. z o.o. Polityką prywatności dot. przetwarzania danych osobowych.
  </p>
  <p style="font-style: italic;">
  Zobowiązuję się do przestrzegania w/w zasad oraz do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
  </p>
  <p style="font-style: italic;">
  Podpis osoby upoważnionej: <span style="font-size: 12px">{{imieNazwisko}}</span>
  </p>
  </div>
  </td></tr>
  </tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'UmowaWspolpracaGitara',
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      imieNazwiskoZamawiajacego: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaDo: '',
      urzadSkarbowy: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaWspolpracaGitara.vue